<div class="container-fluid v2-active h-100">
    <div class="row h-100">
        <!-- Coluna Esquerda -->
        <div class="col-md-4 col-12 d-flex flex-column coluna coluna-esquerda">
            <div class="d-flex flex-column align-items-center justify-content-center h-100">
                @if (enviado === false) {
                    <div class="div-form">
                        <div class="">
                            <img
                                [src]="
                                    themeService.isDark()
                                        ? '../../../../assets/img/icone_amarelo.png'
                                        : '../../../../assets/icone/icone-preto.png'
                                "
                                width="100px"
                            />
                        </div>

                        <div class="py-4">
                            <p class="login-titulo my-3">{{ 'auth.recuperarSenha.title' | transloco }}</p>
                            <p class="login-subtitulo">{{ 'auth.recuperarSenha.subtitle' | transloco }}</p>
                        </div>

                        <form class="form" [formGroup]="form" (ngSubmit)="salvar()">
                            <div class="w-100">
                                <span>{{ 'auth.recuperarSenha.emailLabel' | transloco }}</span> <br />
                            </div>

                            <div class="w-100 mt-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'auth.recuperarSenha.emailField' | transloco }}</mat-label>
                                    <input type="email" matInput formControlName="email" />
                                    @if (form.get('email')?.invalid && form.get('email')?.touched) {
                                        @if (form.get('email')?.errors?.['required']) {
                                            <mat-error>{{ 'auth.recuperarSenha.required' | transloco }}</mat-error>
                                        } @else if (form.get('email')?.errors?.['email']) {
                                            <mat-error>{{ 'auth.form.emailInvalid' | transloco }}</mat-error>
                                        }
                                    }
                                </mat-form-field>
                            </div>

                            <div class="w-100 py-3">
                                <button mat-stroked-button [disabled]="form.invalid" class="w-100" type="submit">
                                    {{ 'auth.recuperarSenha.submit' | transloco }}
                                </button>
                            </div>

                            <div class="div-esqueci-senha py-3">
                                <span
                                    ><a class="link" [href]="hubLoginUrl"
                                        >{{ 'auth.recuperarSenha.alreadyHaveAccount' | transloco }}
                                        <b>{{ 'auth.recuperarSenha.signIn' | transloco }}</b></a
                                    ></span
                                >
                            </div>
                        </form>
                    </div>
                }

                @if (enviado === true) {
                    <div class="div-form mt-3 p-3">
                        <div class="row my-4">
                            <div class="col-12">
                                <p>{{ 'auth.recuperarSenha.successMessage' | transloco }}</p>
                            </div>
                        </div>

                        <div class="row my-4">
                            <div class="col-12">
                                <div class="div-esqueci-senha">
                                    <span
                                        ><a class="link" [href]="hubLoginUrl">{{
                                            'auth.recuperarSenha.backToLogin' | transloco
                                        }}</a></span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div class="d-flex justify-content-end align-items-center gap-2 mb-2">
                    <app-theme-switcher [showTooltip]="false"></app-theme-switcher>
                    <app-language-toggle></app-language-toggle>
                </div>
            </div>
        </div>

        <div
            class="col-md-8 d-none d-md-flex flex-column justify-content-center align-items-center coluna coluna-direita"
        >
            <app-auth-right-column></app-auth-right-column>
        </div>
    </div>
</div>
